module.exports = __webpack_public_path__ + "img/technology1.2b7d2913.png";